import posthog from 'posthog-js';

import { beforeSend } from '@/lib/tracking/utils/beforeSend';

// Only initialize PostHog if NEXT_PUBLIC_DISABLE_POSTHOG is not set and key is available
const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;

if (!process.env.NEXT_PUBLIC_DISABLE_POSTHOG && posthogKey) {
  // Check if PostHog is already initialized by FrontendTracker
  if (!posthog.__loaded) {
    posthog.init(posthogKey, {
      api_host: '/ingest',
      ui_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://eu.posthog.com',
      defaults: '2025-05-24',
      capture_exceptions: true, // This enables capturing exceptions using Error Tracking
      before_send: beforeSend,
      debug: process.env.NODE_ENV === 'development',
      // Add tracing headers for server-side error context
      __add_tracing_headers: [process.env.NEXT_PUBLIC_SITE_URL || 'localhost:3000'],
    });
  } else if (process.env.NODE_ENV === 'development') {
    console.info('PostHog already initialized by FrontendTracker');
  }
} else if (process.env.NODE_ENV === 'development') {
  console.info('PostHog not initialized (missing NEXT_PUBLIC_POSTHOG_KEY or disabled)');
}
